<section class="login-sec {{bankName}}">
    <div class="container text-center">
        <div class="wrapper logo-genius">
            <img src="assets/images/logo-genius.png" alt="logo">
        </div>
        <div class="login-form-section">
            <div class="company-logo">
                <img src="assets/{{bankName}}/images/bank.png" alt="logo">
            </div>
            <form class="login-form" [formGroup]="verifyloginFrm">
                <mat-form-field appearance="outline" class="col-12">
                    <mat-label>User Name</mat-label>
                    <input type="text" matInput required placeholder="User Name" (keyup)="hidePasswordDivFuntn()"
                        formControlName="userName" autocomplete="off">
                    <mat-error *ngIf="verifyloginFrm.controls['userName'].hasError('required')">User Name
                        required.</mat-error>
                    <mat-error
                        *ngIf="verifyloginFrm.controls['userName'].invalid">{{verifyloginFrm.controls['userName'].getError('incorrect')}}</mat-error>
                </mat-form-field>
            </form>
            <div class="px-3" *ngIf="sumbitbtn">
                <button mat-raised-button color="accent" class="btn-fluide mb20  col-12" *ngIf="verifyButton"
                    (click)="verifyUserName()" [disabled]="showVerify()">Verify</button>
            </div>
            <div *ngIf="hidePasswordDiv">
                <form class="login-form" [formGroup]="loginForm">
                    <mat-form-field appearance="outline" class="  col-12">
                        <mat-label>Password</mat-label>
                        <input type="password" matInput placeholder="Password" formControlName="password"
                            autocomplete="off">
                        <mat-error *ngIf="loginForm.controls['password'].hasError('required')">Password
                            required.</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class=" col-12">
                        <mat-label>Captcha</mat-label>
                        <input matInput onpaste="return false;" onCopy="return false" onCut="return false"
                            placeholder="Enter Captcha" value="Captcha" id="userName" class="captchaFeild"
                            formControlName="captcha" autocomplete="off" required minlength="6" maxlength="6"
                            onkeyup="this.value = this.value.toUpperCase();" />
                        <mat-error *ngIf="loginForm.controls['captcha'].hasError('required')">Captcha is
                            required.</mat-error>
                        <mat-error *ngIf="loginForm.controls['captcha'].hasError('incorrectcaptcha')">Captcha is invalid
                        </mat-error>
                    </mat-form-field>
                    <div id="capt">
                        <span onselectstart="return false" onpaste="return false;" onCopy="return false"
                            onCut="return false" onDrag="return false" onDrop="return false">{{initialCap}}</span>
                        <span style="float: right;">
                            <i class="material-icons" (click)="Cap()">refresh</i>
                        </span>
                    </div>
                    <div class="wrapper login-forgot-section mt10" *ngIf="sumbitbtn">
                        <button mat-raised-button color="accent" class="btn-fluide mb20" (click)="Login2FA()"
                            [disabled]="SubmitVisible()">Login</button>
                    </div>
                    <div *ngIf="ErrorMsg" style="margin-top: 16px;">
                        <mat-error *ngIf="passwordErr">
                            <p style="font-family: Roboto, 'Helvetica Neue', sans-serif;">{{passwordErr}}</p>
                        </mat-error>
                    </div>
                    <mat-spinner  style="margin-top: 77px;width: 30px;height: 30px;margin-left: 165px;"
                        [diameter]="30"></mat-spinner>
                </form>
            </div>
            <div class="text-center mt-30">
                <a href="#" class=" fs-6 text-danger">Forgot Password?</a>
            </div>

        </div>
        <div class="text-center" style="color: white;">
            <div class="wrapper powered-section">
                <p>Powered By <a href="https://insolutionsglobal.com/" target="_blank" color="primary"
                        class="primary-link link">In-Solutions Global</a>
                    <abbr><img src="assets/images/logo-powerby.jpg" alt="logo"></abbr>
                </p>
            </div>
        </div>
    </div>
</section>